/**
 * 定数
 */

/**製品名 */
export const PRODUCT_NAME = "マネーリンク（仮）";

/**発行元 */
export const PUBLISHER = "ソリマチ株式会社";

/** FAQ トップページ */
export const FAQ_URL = "https://member.sorimachi.co.jp/faq/ibpb/";

/** ヘルプページ */
export const HELP_URL = "https://support-moneylink.sorimachi.co.jp";

/** FAQ ページ一覧 */
type FaqItem = {
  title: string;
  url: string;
};

export const faqList: FaqItem[] = [
  { title: "事前申し込みが必要な金融機関について教えてください", url: "https://qa.sorimachi.co.jp/hc/ja/articles/20782947031961-%EF%BC%B1-%E4%BA%8B%E5%89%8D%E7%94%B3%E3%81%97%E8%BE%BC%E3%81%BF%E3%81%8C%E5%BF%85%E8%A6%81%E3%81%AA%E9%87%91%E8%9E%8D%E6%A9%9F%E9%96%A2%E3%81%AB%E3%81%A4%E3%81%84%E3%81%A6%E6%95%99%E3%81%88%E3%81%A6%E3%81%8F%E3%81%A0%E3%81%95%E3%81%84" },
  { title: "「ＩＢ連携オプション」で設定した情報を「ＭｏｎｅｙＬｉｎｋ」に引き継ぐ方法", url: "https://qa.sorimachi.co.jp/hc/ja/articles/234989808-%EF%BC%B1-%EF%BC%A9%EF%BC%A2%E9%80%A3%E6%90%BA%E3%82%AA%E3%83%97%E3%82%B7%E3%83%A7%E3%83%B3-%E3%81%A7%E8%A8%AD%E5%AE%9A%E3%81%97%E3%81%9F%E6%83%85%E5%A0%B1%E3%82%92-%EF%BC%AD%EF%BD%8F%EF%BD%8E%EF%BD%85%EF%BD%99%EF%BC%AC%EF%BD%89%EF%BD%8E%EF%BD%8B-%E3%81%AB%E5%BC%95%E3%81%8D%E7%B6%99%E3%81%90%E6%96%B9%E6%B3%95" },
  { title: "初期設定方法（初めてご利用いただく方）", url: "https://qa.sorimachi.co.jp/hc/ja/articles/360044390291-%EF%BC%B1-%E5%88%9D%E6%9C%9F%E8%A8%AD%E5%AE%9A%E6%96%B9%E6%B3%95-%E5%88%9D%E3%82%81%E3%81%A6%E3%81%94%E5%88%A9%E7%94%A8%E3%81%84%E3%81%9F%E3%81%A0%E3%81%8F%E6%96%B9" },
  { title: "インターネットバンキングの口座情報を追加する方法", url: "https://qa.sorimachi.co.jp/hc/ja/articles/360044391331-%EF%BC%B1-%E3%82%A4%E3%83%B3%E3%82%BF%E3%83%BC%E3%83%8D%E3%83%83%E3%83%88%E3%83%90%E3%83%B3%E3%82%AD%E3%83%B3%E3%82%B0%E3%81%AE%E5%8F%A3%E5%BA%A7%E6%83%85%E5%A0%B1%E3%82%92%E8%BF%BD%E5%8A%A0%E3%81%99%E3%82%8B%E6%96%B9%E6%B3%95" },
];

/**利用規約ページ */
export const TERMS_URL = "https://sorimachi.co.jp/lp-moneylink/terms.pdf";

/**個人情報保護基本方針ページ */
export const PRIVACY_POLICY_URL = "https://sorimachi.co.jp/about/privacy.php";

/**入力不可文字一覧 */
export const INVALID_CHARACTERS = /[<>&"'`{}();#%+?=\\\/:*|$\0\n\r\t[\],]/;

/** ハイフンとして扱う候補文字 */
export const HYPHEN_CANDIDATES = /[ー－―—–ｰ‐]/g;